import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef, NbDialogService } from '@nebular/theme';
import { MediathequeComponent } from '../../../shared/mediatheque/mediatheque.component';
import { TestBed } from '@angular/core/testing';
import { Config } from '../../../config/config';
import { plainToClass } from 'class-transformer';
import { Page } from '../../../shared/data/page';

@Component({
  selector: 'ngx-edit-menu',
  templateUrl: './edit-menu.component.html',
  styleUrls: ['./edit-menu.component.scss']
})
export class EditMenuComponent implements OnInit {

  @Input() id: number;
  @Input() typeT;
  @Input() lien;
  @Input() cible;
  @Input() nome;
  
  arrayjson:any = [];
  hideLoader =true;
  hideButon = false;
  title;
  href;
  target;
  typeTarget = '';
  hideCible = true;
  name;
  hideLien = false;
  changeValue ="article";
  selecta = "Article";
  childrens = {href: "", lien:"", typeTarget: "",target:"",title:"",name:"",id:this.id,childrens: []};
  options;
  hello="Lien personnalisé";
  
  // apropos = ['creation','actionnariat','vision','organisation','partenaires'];
  // projets = ['projet pilot de la smid','projets à venir'];
  // promotion = ["Le programme","Conditions d'éligibilites","souscrire au programme","Deposer une reclammation"];
  // economie =["Le programme","Conditions d'éligibilites","souscrire au programme","Deposer une reclammation"];

  apropos = ['creation','actionnariat','vision','organisation','apropos','mission'];
  projets = ['projet pilot de la smid','projets à venir'];
  promotion = ["programme","egibilite","souscription","reclamation","promotion"];
  economie =["programme","egibilite","souscription","reclamation","promotion"];
  cibles:any = [];
  hideFileButon = false;
  imageChoisie;
  pages: Page[];

  selectedItems = [];
  empSelected = [];
  dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'short_title',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  constructor(protected dialogRef: NbDialogRef<EditMenuComponent>,private apiService:ApiService,private dialogService: NbDialogService,private sendeurService:EventSendeurService,public toastr:NbToastrService) {
   
   }

  ngOnInit() {

    this.changeValue = "Lien personnalisé";
    this.typeTarget = "Lien personnalisé";

    // this.imageChoisie === undefined;
    this.sendeurService.fichier.asObservable().subscribe(data =>{
      // console.log(data);
      if(data){
        // var fil = JSON.parse(localStorage.getItem("fichier"));
         this.href = Config.urlserveur + data.url; 
        // console.log(this.imageChoisie);
      }
     
    })
    
    /* if(this.cible ==="Conditions d'éligibilites"){
      this.cible ="Conditions_d'éligibilites"
    }
    if(this.cible ==="Le programme"){
      this.cible ="Le_programme"
    }
    if(this.cible ==="souscrire au programme"){
      this.cible ="souscrire_au_programme"
    }
    if(this.cible ==="Deposer une reclammation"){
      this.cible ="Deposer_une_reclammation"
    } */

    this.target = this.cible;
    this.name = this.nome;
    this.href = this.lien;
    this.typeTarget = this.typeT;
    this.options = ['Page','Article'];
    this.selecta = this.typeTarget;

    console.log(this.typeT);

    this.getPage();
   
  }

  cancel(){
    this.dialogRef.close();
  }

  close(){
    this.dialogRef.close();
  }

  editMenu(){
   
    this.childrens.target = this.target;
    this.childrens.typeTarget= this.typeTarget;
    this.childrens.href = this.href;
    this.childrens.id = this.id;
    this.childrens.name = this.name;
    this.childrens.lien = this.imageChoisie;
    if(this.typeTarget ===undefined || this.typeTarget ===null){
      this.toastr.danger("Vous devez choisir un type","erreur");
      return false;
    }
    console.log(this.typeTarget);
    this.sendeurService.sendMenuEvent(this.childrens);
    this.dialogRef.close(this.childrens);
  
  }

  findUrl(){
    // localStorage.setItem("photo","fichier");
    this.dialogService.open(MediathequeComponent, {context: { mime: 'all'}});
  }



  // dataChanged($event){
  //   this.changeValue = $event;
    
  //   console.log($event);
  //   this.typeTarget = $event;
   
  // }

  dataChanged($event){
    this.hideCible = false;
    this.changeValue = $event;
    this.typeTarget = $event;
    console.log($event);
    this.typeTarget = $event;
    /* if($event ==='Accueil'){
      this.hideCible = true;
      this.hideLien = true;
      this.hideFileButon = true;
      localStorage.removeItem("fichier");
       this.sendeurService.sendArticleEvent(8);
       this.imageChoisie = "";
      this.sendeurService.fichier.next(null);
    }
  
    if($event ==='Lien personnalisé'){
      localStorage.removeItem("fichier");
       this.sendeurService.sendArticleEvent(8);
       this.imageChoisie = "";
      this.sendeurService.fichier.next(null);
      this.hideCible = true;
      this.hideLien = false;
      this.hideFileButon = false;
    }
    
  
    if($event ==='Actualités'){
      localStorage.removeItem("fichier");
       this.sendeurService.sendArticleEvent(8);
       this.imageChoisie = "";
      this.sendeurService.fichier.next(null);
      this.hideCible = true;
      this.hideLien = true;
      this.hideFileButon = true;
    
    }
  
    if($event ==='A propos'){
      localStorage.removeItem("fichier");
       this.sendeurService.sendArticleEvent(8);
       this.imageChoisie = "";
      this.sendeurService.fichier.next(null);
      this.hideCible = false;
      this.cibles = [];
      this.cibles = this.apropos;
      this.hideLien = true;
      this.hideFileButon = true;
    }
  
    if($event ==='Promotion immobilière'){
      localStorage.removeItem("fichier");
       this.sendeurService.sendArticleEvent(8);
       this.imageChoisie = "";
      this.sendeurService.fichier.next(null);
      this.hideCible = false;
      this.cibles = [];
      this.cibles = this.promotion;
      this.hideLien = true;
      this.hideFileButon = true;
    }
  
    if($event ==='Economie numérique'){
      localStorage.removeItem("fichier");
       this.sendeurService.sendArticleEvent(8);
       this.imageChoisie = "";
      this.sendeurService.fichier.next(null);
      this.hideCible = false;
      this.cibles = [];
      this.cibles = this.economie;
      this.hideLien = true;
      this.hideFileButon = true;
    }
  
    if($event ==='Projets structurant'){
      localStorage.removeItem("fichier");
       this.sendeurService.sendArticleEvent(8);
       this.imageChoisie = "";
      this.sendeurService.fichier.next(null);
      this.hideCible = false;
      this.cibles = [];
      this.cibles = this.projets;
      this.hideLien = true;
      this.hideFileButon = true;
    }
  
    if($event ==='A propos'){
      localStorage.removeItem("fichier");
       this.sendeurService.sendArticleEvent(8);
       this.imageChoisie = "";
      this.sendeurService.fichier.next(null);
      this.hideCible = false;
      this.cibles = [];
      this.cibles = this.apropos;
      this.hideLien = true;
      this.hideFileButon = true;
    } */
   
  }
  

  getPage(){

    this.apiService.getAllPageProvider().subscribe(data =>{

      // console.log(data);

      this.pages = plainToClass(Page, data);

      for(let i=0 ; i < this.pages.length; i++){

        if(this.pages[i].slug === this.cible) {
          this.empSelected = [this.pages[i]];
          console.log(this.pages[i]);
        }

      }

      // this.empSelected = this.pages;
      /* const tmps = data as any[];   
      this.pages = tmps.map(tmp => {
        return {  
          slug: tmp.slug,   
          id:tmp.id,
          titre:tmp.titre
        };
       
      }); */

    },(err) =>{

      if(err.error.code ===401){
        this.toastr.danger("Authentification non autorisé");
      }

      if(err.error.code ===500){
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }
    
    })
  }

  onItemSelect(select: any) {

    const index = this.pages.findIndex( item => item.id == select.id)
    this.target = this.pages[index].slug;

    // console.log(item);
   
  }

  
  onItemDeSelect(items: any){
    this.target = '';
  }

  onSelectAll(items: any) {
    
  }

  onDeSelectAll($event){
    
  }

  onUnSelectAll(){
    
  }

  onDropDownClose($event){
    
  }

  


  // updateMenu(){
  //   this. hideLoader =false;
  //    this.hideButon = true;
  //    this.apiService.updateMenuProvider(this.nom,this.id).subscribe(data =>{
  //      this.toastr.success("Menu modifié avec success");
  //      this.dialogRef.close();
  //    },(err) =>{
  //      console.log(err);
  //      this. hideLoader =true;
  //      this.hideButon = false;
  //      this.toastr.danger("echec, il se peut qu'un nom de menu similaire existe déjà");
  //    })
  //  }
 

  //  getOneMenu(){
  //    this.apiService.getOneMenuProvider(this.id).subscribe((data:any) =>{
  //      this.nom = data.nom
  //    })
  //  }


}
